// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"5c6008f3","453":"eba4445a","626":"d413ecb5","651":"c2c23622"}[chunkId] + ".chunk.js";
};